export enum TransformType {
  None,
  UpperCase,
  Title,
  UpperCaseNoSpaces
}

export enum InputType {
  Postcode,
  Numeric,
  AlphaNumeric,
  NiNumber,
  VehicleRegistration,
  Decimal,
  CaseReference,
  Name,
  PinCode,
  Email,
  AddressLine
}

export enum FormStatus {
    Completed,
    Incomplete,
    Error,
    Empty
}

export enum StatusBarType {
    YourDetails,
    YourAccident,
    YourInjuries,
    YourVehicle,
    InvolvedParties,
    Other
}

export enum ScreenType {
    Home,
    Personal,
    Employment,
    YourAccidentYourInvolvement,
    YourAccidentTimeLocation,
    YourAccidentDescription,
    YourInjuriesDetails,
    YourInjuriesMedicalAttention,
    YourVehicle,
    ResponsibleParty,
    Passengers,
    PoliceAndWitnesses,
    Summary,
    TermsOfService,
    LogOut
}

export enum FormName {
    Personal = 'Personal',
    PersonalAddress = 'Personal-address',
    Employment = 'Employment',
    YourAccidentInvolvement = 'YourAccidentInvolvement',
    YourAccidentLocation = 'YourAccidentLocation',
    YourAccidentDescription = 'YourAccidentDescription',
    YourInjuriesDetails = 'YourInjuriesDetails',
    YourInjuriesMedicalAttention = 'YourInjuriesMedicalAttention',
    YourVehicle = 'YourVehicle',
    ResponsibleParty = 'ResponsibleParty',
    ResponsiblePartyDriverAddress = 'Third-party-driver-address',
    ResponsiblePartyOwnerAddress = 'Third-party-owner-address',
    Passengers = 'Passengers',
    PoliceAndWitnesses = 'Police'
}

export namespace FormControlNames  {
    export enum Personal {
        Title = 'personal-title',
        FirstName = "personal-first-name",
        MiddleName = 'personal-middle-name',
        Surname = 'personal-surname',
        Dob = 'personal-dob',
        Email = 'personal-email',
        PrimaryPhoneNoMobile = 'primary-telephone-mobile',
        SecondaryPhoneNo = 'secondary-telephone',
        Address = 'personal-postcode'
    }

    export enum Employment {
        Status = 'employment-status',
        Occupation = 'employment-occupation',
        TimeOffWork = 'employment-time-off-work',
        StillOngoing = 'employment-still-ongoing',
        StillOfWork = 'employment-still-off-work',
        Ni = 'employment-ni',
        NoNi = 'employment-no-ni'
    }

    export enum AccYourInvolvement {
        VehicleType = 'accident-vehicle-type',
        HowInvolved = 'accident-how-involved',
        HowManyPeople = 'accident-how-many-people',
        EvidenceOfTravel = 'accident-evidence-of-travel',
        DriverAtFault = 'accident-driver-at-faukt',
        AreYouVehicleOwner = 'accident-are-you-vehicle-owner',
        DriverFirstName = 'accident-driver-first-name',
        DriverSurname = 'accident-driver-surname',
        DriverEmail = 'accident-driver-email',
        DriverPrimaryPhoneNo = 'accident-driver-primary-phone-no',
        DriverSecondaryPhoneNo = 'accident-driver-secondary-phone-no',
        IsWearingSeatbelt = 'accident-is-wearing-seatbelt',
        HowManyDrivers = 'accident-how-many-drivers-involved'
    }

    export enum AccTimeAndLocation {
        Date = 'accident-date',
        Time = 'accident-time',
        Country = 'accident-country',
        Road = 'accident-location-road',
        Town = 'accident-location-town'
    }

    export enum AccDescription {
        Description = 'accident-description',
        Summary = 'accident-summary',
        EstimatedSpeed = 'accident-estimated-speed',
        CctvOrDashcam = 'accident-cctv-or-dashcam',
        HasAccidentPhoto = 'accident-has-photo'
    }

    export enum InjuryDetails {
        WhiplashSevere = 'injury-whiplash-severe',
        WhiplashSevereWhy = 'injury-whiplash-severe-why',
        PreExistingConditions = 'injury-pre-existing-conditions',
        PreExistingConditionsDescription = 'injury-pre-existing-conditions-description',
        CircumstancesExceptional = 'injury-circumstances-exceptional',
        CircumstancesExceptionalIfYesWhy = 'injury-circumstances-exceptional-if-yes-why'
    }

    export enum InjuryMedicalAttention {
        MedicalAttentionSought = 'medical-attention-sought',
        GpAttentionSought = 'medical-gp-attention-sought',
        HospitalAttentionSought = 'medical-hospital-attention-sought',
        ParamedicAttentionSought = 'medical-paramedic-attention-sought',
        OtherAttentionSought = 'medical-other-attention-sought',
        HospitalName = 'injuries-hospital-name',
        NightsInHospital = 'injuries-nights-in-hospital',
        DoctorRecommendsFurtherTreatment = 'injuries-doctor-further-treatment'
    }

    export enum YourVehicle {
        Registration = 'vehicle-registration',
        Make = 'vehicle-make',
        Model = 'vehicle-model',
        Colour = 'vehicle-color',
        ClaimingDamage = 'vehicle-claim-damage',
        RepairHelpRequired = 'vehicle-help-repairing',
        RepairHelpNotRequiredReason = 'vehicle-help-repairing-reason',
        TemporaryReplacementVehicleNeeded = 'vehicle-need-temporary-vehicle',
        TemporaryReplacementVehicleNeededReason = 'vehicle-need-temporary-vehicle-reason',
        WhatIsTheNameOfHiringCompany = 'vehicle-name-of-hiring-company'
    }

    export enum ResponsibleParty {
        HaveTpDetails = 'tp-have-detail',
        ObtainedTpDetail = 'tp-how-obtain-details',
        CanGetTpDetail = 'p-how-get-details-can-you-get-them',
        Registration = 'tp-registration',
        Make = 'tp-vehicle-make',
        Model = 'tp-vehicle-model',
        Colour = 'tp-vehicle-color',
        DriverForename = 'tp-driver-first-name',
        DriverMiddleName = 'tp-driver-middle-name',
        DriverSurname = 'tp-driver-surname',
        VehicleIsForeign = 'tp-foreign-vehicle',
        IsCommercialVehicle = 'tp-commercial-vehicle',
        TpOwnerName = 'tp-owner-name',
        OtherVehiclesInvolved = 'tp-other-vehicles',
        EstimatedSpeed = 'tp-estimated-speed',
        PrimaryPhoneNoMobile = 'tp-primary-phone-no',
        SecondaryPhoneNo = 'tp-secondary-phone-no',
        VehicleInsuranceDetailsKnown = 'tp-vehicle-insurance-details-known',
        InsurerNameDetails = 'tp-insurer-name-and-details',
        Address = 'third-party-owner-postcode'
    }

    export enum Passengers {
        NmberOfPassengers = 'passengers-number-of-passengers',
        CopyConsent = 'passengers-copy-consent'
    }

    export enum PoliceAndWitness {
        Involved = 'ip-police',
        Station = 'ip-police-station',
        PoliceJurisdiction = 'ip-police-jurisdiction',
        ReferenceNumber = 'ip-police-reference-number',
        HasWitnesses = 'ip-has-independent-witnesses'
    }
}

export enum PortalEnum {
    OIC = 1,
    MOJ = 2,
    MultiTrack = 3,
    MibUntraced = 4,
    ForeignVehicle = 5
}